import { useEffect, useState } from "react";
import { Card, Flex, Row, Col, Divider } from 'antd';
import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { useAuthentication } from "../provider/Auth";
import { useWS } from '../provider/WS';
import { IMETAMessageType } from '../config/imetahuman';

const { v4: uuidv4 } = require('uuid');



export const UI = (props) => {


    const navigate = useNavigate();
    const { message, lastJsonMessage } = useWS();

    const [counter, setCounter] = useState(15);
    const [accountData, setAccountData] = useState();
    const { check, getConfig, updateConfig } = useAuthentication();


    const isValidUrl = urlString => {
        try {
            return Boolean(new URL(urlString));
        }
        catch (e) {
            return false;
        }
    }

    const checkServer = () => {
        message({
            type: IMETAMessageType.MMServer,
            uid: uuidv4(),
            user: accountData.username
        });
    }

    useEffect(() => {

        console.log('Nuovo messaggio ricevuto:', lastJsonMessage);
        if (lastJsonMessage != null) {

            if (lastJsonMessage.type === IMETAMessageType.MMResponse) {
                if (lastJsonMessage.error !== '') {
                    console.log(lastJsonMessage.error);
                } else {

                    if (lastJsonMessage.server !== '') {
                        let config = getConfig();
                        config.pixelstreamingUrl = lastJsonMessage.server;
                        updateConfig(config);
                        navigate("/console");

                    }

                }
            }


        }




    }, [lastJsonMessage]);

    useEffect(() => {
        try {
            check().then(user => {
                if (user) {
                    setAccountData(user);
                    if (isValidUrl(user.pixelstreamingUrl)) {
                        navigate("/console");
                    } else {
                        message({
                            type: IMETAMessageType.MMServer,
                            uid: uuidv4(),
                            user: user.username
                        });
                    }
                } else {
                    navigate("/");
                }
            });

        } catch (e) {
            navigate("/");
        }

    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter((prevCounter) => {
                if (prevCounter <= 0) {
                    checkServer();
                    return 15;
                } else {
                    return prevCounter - 1;
                }
            });

        }, 1000);

        return () => clearInterval(interval);
    }, [accountData]);




    return (
        <>

            <Flex className='Main' justify='center' align='center'>
                <Card className='Login'
                    bordered={false}
                    style={{ width: 550 }}
                >
                    <Row>
                        <Col flex="40px"><CheckCircleFilled style={{ fontSize: '24px', color: '#64eb34' }} /></Col>
                        <Col flex="auto">Authentication</Col>
                    </Row>
                    <Divider orientation="left"></Divider>
                    <Row>
                        <Col flex="40px"><CheckCircleFilled style={{ fontSize: '24px', color: '#64eb34' }} /></Col>
                        <Col flex="auto">Download configuration</Col>
                    </Row>
                    <Divider orientation="left"></Divider>
                    <Row>
                        <Col flex="40px"><LoadingOutlined style={{ fontSize: '24px', color: '#ebb434' }} /></Col>
                        <Col flex="auto">Waiting for available resources, try again in <b>{counter}</b> seconds</Col>
                    </Row>

                </Card>
            </Flex>
        </>
    );

};